import { createContext, useContext, type ReactNode } from 'react'
import type { UseExchangeRatesResult } from '@/hooks/useExchangeRates'

const RatesContext = createContext<UseExchangeRatesResult | null>(null)

export function RatesProvider({
  value,
  children,
}: {
  value: UseExchangeRatesResult
  children: ReactNode
}) {
  return <RatesContext.Provider value={value}>{children}</RatesContext.Provider>
}

export function useRates(): UseExchangeRatesResult {
  const ctx = useContext(RatesContext)
  if (!ctx) throw new Error('useRates must be used within RatesProvider')
  return ctx
}
